import 'src/app.scss'

import React, { Suspense, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Routes, useLocation, useNavigate } from 'react-router'
import { routes } from 'src/navigation/routes'

import { HEADER_LINK } from './config'
import { TO_INTRO_S0 } from './navigation'
import { shoot } from './redux/actions'
import { select_error } from './redux/store'
import { Button, Footer, Header, Modal } from './widgets'

const App: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const error = useSelector(select_error())

  useEffect(() => {
    dispatch(shoot.reduce_error())
    window.scrollTo(0, 0)
  }, [location])

  /**
   * Render functions
   */
  const render_header = (progress?: string) => (
    <Header
      on_close={() => window.open(HEADER_LINK, '_blank')}
      progress={progress}
      version={true}
    />
  )

  const render_error = (hidden_error?: boolean) => (
    <Modal visible={!hidden_error && !!error} on_close={() => dispatch(shoot.reduce_error())}>
      <>
        <div className="font-56 c-302c2c">{'Ops!'}</div> {/* TODO */}
        <div className="font-20 c-7f7f7f pre-line mt-4">{error?.description_fe}</div>
        <Button
          flavor="transparent_primary_next"
          text={t('commons.back_home')}
          classes="mt-4 p-0"
          on_press={() => navigate(TO_INTRO_S0)}
        />
      </>
    </Modal>
  )

  const render_agency_error = () => {
    if (error?.saga_type === 'SAGA_RESOLVE_AGENCIES') {
      dispatch(shoot.reduce_error())
      return <>{window.open('https://www.gruppoitas.it/supporto/agenzie', '_blank')}</>
    }
  }

  return (
    <main className="imain">
      <Suspense fallback={<div />}>
        <Routes>
          {routes?.map(({ path, component, progress, hidden_error, hidden_footer }, idx) => (
            <Route
              key={idx}
              path={path}
              element={
                <>
                  {render_header(progress)}
                  {render_error(hidden_error)}

                  <Container className="col-lg-11 col-12 flex-1">{component}</Container>

                  {!hidden_footer && <Footer progress={progress} />}
                </>
              }
            />
          ))}
          {render_agency_error()}
        </Routes>
      </Suspense>
    </main>
  )
}

export default App
